import { useState, useEffect } from 'react'

export const useTutorialStatus = (tutorialId) => {
	const [hasSeenTutorial, setHasSeenTutorial] = useState(false)
	const [isLoading, setIsLoading] = useState(true)
	const [error, setError] = useState(null)

	useEffect(() => {
		const fetchViewedTutorials = async () => {
			try {
				const response = await fetch(
					`${process.env.REACT_APP_REQUEST_URL}/api/v1/tutorials/viewed`,
					{
						credentials: 'include',
						headers: {
							Accept: 'application/json',
							'Content-Type': 'application/json',
						},
					}
				)

				if (response.ok) {
					const data = await response.json()
					const viewedTutorials = data.data?.tutorialIds || []
					localStorage.setItem(
						'viewedTutorials',
						JSON.stringify(viewedTutorials)
					)
					setHasSeenTutorial(viewedTutorials.includes(tutorialId))
				}
			} catch (err) {
				console.error('Error fetching viewed tutorials:', err)
				setError(err)
				// Fallback to localStorage if API fails
				const localTutorials = JSON.parse(
					localStorage.getItem('viewedTutorials') || '[]'
				)
				setHasSeenTutorial(localTutorials.includes(tutorialId))
			} finally {
				setIsLoading(false)
			}
		}

		fetchViewedTutorials()
	}, [tutorialId])

	// Update local state when tutorial is marked as viewed
	const markAsViewed = (tutorialId) => {
		const viewedTutorials = JSON.parse(
			localStorage.getItem('viewedTutorials') || '[]'
		)
		if (!viewedTutorials.includes(tutorialId)) {
			const updatedTutorials = [...viewedTutorials, tutorialId]
			localStorage.setItem(
				'viewedTutorials',
				JSON.stringify(updatedTutorials)
			)
			setHasSeenTutorial(true)
		}
	}

	return { hasSeenTutorial, isLoading, error, markAsViewed }
}
